import { useMatch } from 'react-router-dom';

import { useRequest } from '@Contexts/Request';

import type { PathPattern } from 'react-router-dom';

function useRouteMatch(pattern: PathPattern) {
  const { region } = useRequest();

  const matchWithoutRegion = useMatch(pattern);

  const matchWithRegion = useMatch({
    ...pattern,
    path: `/${region}${pattern.path}`,
  });
  return [matchWithoutRegion, matchWithRegion].some(Boolean);
}

export default useRouteMatch;
